import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";
import * as XLSX from "xlsx";

const AllUser = () => {

  const { callApi: fetchUsers } = useApi(
    "/admin/users/users-hierarchy/new/v1/not-of-type",
    "GET"
  );

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const [openRow, setOpenRow] = useState(null);

  const fetchUserList = async () => {

    try {

      setLoading(true);

      const res = await fetchUsers();

      if (Array.isArray(res)) {
        setUsers(res);
      }

    } catch (error) {

      console.error(error);

    } finally {

      setLoading(false);

    }

  };

  useEffect(() => {
    fetchUserList();
  }, []);

  /* EXCEL DOWNLOAD */

  const downloadExcel = () => {

    const worksheet = XLSX.utils.json_to_sheet(users);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

    XLSX.writeFile(workbook, "AllUsers.xlsx");

  };

  const toggleRow = (index) => {

    if (openRow === index) {
      setOpenRow(null);
    } else {
      setOpenRow(index);
    }

  };

  return (

    <div className="w-full">

      <div className="flex justify-between items-center mb-4">

        <h2 className="text-xl font-bold text-[#0A2A4F]">
          All Users
        </h2>

        <button
          onClick={downloadExcel}
          className="bg-green-600 text-white px-5 py-2 rounded-full shadow hover:bg-green-700"
        >
          Download XLS
        </button>

      </div>

      <div className="rounded-xl border border-gray-300 bg-white shadow-sm overflow-auto">

        <table className="w-full text-sm border-collapse">

          <thead className="bg-[#0A2A4F] text-white">

            <tr>
              <th className="border px-3 py-2">BP User ID</th>
              <th className="border px-3 py-2">Username</th>
              <th className="border px-3 py-2">Full Name</th>
              <th className="border px-3 py-2">Mobile</th>
              <th className="border px-3 py-2">Role</th>
              <th className="border px-3 py-2">Merchant Balance</th>
              <th className="border px-3 py-2">Status</th>
              <th className="border px-3 py-2">View</th>
            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>
                <td colSpan="7" className="text-center py-6">
                  Loading...
                </td>
              </tr>

            ) : users.length > 0 ? (

              users.map((user, index) => (

                <React.Fragment key={index}>

                  <tr className="hover:bg-gray-50">

                    <td className="border px-3 py-2">
                      {user.bpUserId}
                    </td>

                    <td className="border px-3 py-2">
                      {user.username}
                    </td>

                    <td className="border px-3 py-2">
                      {user.fullName}
                    </td>

                    <td className="border px-3 py-2">
                      {user.mobileNumber}
                    </td>

                    <td className="border px-3 py-2">
                      {user.role}
                    </td>
                    <td className="border px-3 py-2 font-semibold text-green-700">
                      ₹ {user.merchantBalance}
                    </td>

                    <td className="border px-3 py-2">

                      <span
                        className={`font-semibold ${user.status === "ACTIVE"
                          ? "text-green-600"
                          : "text-red-600"
                          }`}
                      >
                        {user.status}
                      </span>

                    </td>

                    <td className="border px-3 py-2 text-center">

                      <button
                        onClick={() => toggleRow(index)}
                        className="text-blue-600 hover:text-blue-800 text-lg"
                      >
                        👁
                      </button>

                    </td>

                  </tr>

                  {openRow === index && (

                    <tr>

                      <td
                        colSpan="7"
                        className="border bg-gray-50 p-4"
                      >

                        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 text-sm">

                          {Object.entries(user).map(([key, value]) => (

                            <div key={key} className="border p-2 rounded">

                              <span className="font-semibold text-gray-600">
                                {key}
                              </span>

                              <div className="text-gray-800">
                                {value || "-"}
                              </div>

                            </div>

                          ))}

                        </div>

                      </td>

                    </tr>

                  )}

                </React.Fragment>

              ))

            ) : (

              <tr>
                <td colSpan="7" className="text-center py-6">
                  No Users Found
                </td>
              </tr>

            )}

          </tbody>

        </table>

      </div>

    </div>

  );

};

export default AllUser;